export default "__VITE_ASSET__BsL6k5B___"